export default __webpack_public_path__ + "static/media/brain2.ac107550.jpg";